import React, { FC, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { useAccountWriteContext } from '@context/AccountContextContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import { Button } from '@ui/components/Button'
import { ContentBlock } from '@ui/components/ContentBlock/ContentBlock'
import { FeatureIcon } from '@ui/components/FeatureIcon/FeatureIcon'
import { CircleCloseIcon } from '@ui/icons/CircleClose.icon'

import { CommonPaths } from '@utils/path'

import { TickmillProductType } from '@model/TickmillProductType'

import { useLandingPage } from '@hooks/useLandingPage'
import { useScrollToTop } from '@hooks/useScrollToTop'

import { FullScreenFooter } from '@shared/templates/FullScreenLayout'
import { TestTemplate } from '@shared/templates/TestTemplate'

import { useResolvedAppTestProduct } from './hooks/useResolvedAppTestProduct'

export const ProductAppropriatenessTestRiskDeclinedPage: FC = () => {
  useScrollToTop()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const locale = useSessionLanguage()
  const contentRef = useRef<HTMLDivElement>(null)
  const { refreshAccount } = useAccountWriteContext()
  const { getLandingPage } = useLandingPage()
  const resolvedProductId = useResolvedAppTestProduct()

  const handleClose = async () => {
    await refreshAccount(locale)
    navigate(
      resolvedProductId === TickmillProductType.SQF
        ? CommonPaths.TradersRoomWallets
        : getLandingPage()
    )
  }

  return (
    <TestTemplate maxWidth={600} contentRef={contentRef} noHeader>
      <ContentBlock
        variant='voucher'
        icon={<FeatureIcon size='lg' icon={CircleCloseIcon} bg='surface-danger-high-em' />}
        title={t('SQF.Not Suitable')}
        description={t('SQF.result.marginalRejected')}
      />
      <FullScreenFooter contentRef={contentRef}>
        <Button.Primary fullWidth size='lg' onClick={handleClose}>
          {t('Close')}
        </Button.Primary>
      </FullScreenFooter>
    </TestTemplate>
  )
}
